import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataComponent } from './data.component';
import { SharedModule } from '../shared/shared.module';
import { DataHeroComponent } from './components/data-hero/data-hero.component';
import { PartnersComponent } from './components/partners/partners.component';
import { MatCardModule } from '@angular/material/card';



@NgModule({
  declarations: [
    DataComponent,
    DataHeroComponent,
    PartnersComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatCardModule
  ]
})
export class DataModule { }
